/* eslint-disable */
<template>
  <!-- <div class="mid_content">
   <div class="container ">
     <div class="row  justify-content-center" >
       <div class="col-5 center-hold-cpw">
         <h2 class="mb-4 title-sign">Account Information</h2>
         <div class="form-group" style="float: left;width: 100%;">
            <select class="form-control name_prefix" v-model="newstaff.title">
               <option value="Dr">Dr.</option>
               <option value="Prof">Prof.</option>
               <option value="Mr">Mr.</option>
               <option value="Mrs">Mrs.</option>
               <option value="Miss">Miss.</option>
            </select>
            <input name="firstname" placeholder="Full name" v-model="newstaff.full_name" class="form-control input name" data-vv-id="3" aria-required="true" aria-invalid="false"  type="text">
            <span class="help is-danger required" v-if="this.err_fullname"> Please enter full name</span>
            <span class="help is-danger required" v-if="this.err_name_regex"> Please alphabets Only</span>
            <div></div>
         </div>
         <div class="form-group">
            <input name="email" placeholder="Email address" v-model="newstaff.email" class="form-control input" data-vv-id="3" aria-required="true" aria-invalid="false" type="text">
            <span class="help is-danger required" v-if="this.err_email"> Please enter email address</span>
            <span class="help is-danger required" v-if="this.err_email_regex"> Please enter valid email address</span>
         </div>
         <div class="form-group f-width left">
            <select class="form-control name_prefix" v-model="newstaff.countrycode">
               <option v-for="(item, index) in country_code" v-bind:value="item.code" v-bind:key="index">{{ item.dial_code }}</option>
            </select>
            <input name="newpass" placeholder="Mobile number" maxlength="15" v-model="newstaff.mobile" class="form-control input name" data-vv-id="4" aria-required="true" aria-invalid="false" type="tel">
            <span class="help is-danger required" v-if="this.err_mobile"> Please enter mobile number</span>
            <span class="help is-danger required" v-if="this.err_mobile_regex"> Please enter valid mobile number</span>
         </div>
         <div class="form-group f-width left">
            <input name="businessname" placeholder="Clinic name" maxlength="25" v-model="newstaff.business_name" class="form-control input" data-vv-id="4" aria-required="true" aria-invalid="false" type="text">
            <span class="help is-danger required" v-if="this.err_businessname"> Please enter clinic name</span>           
         </div>
         
         <div class="form-group f-width left">
            <b class="f-width left cmail">https://<input style="padding: 8px 10px;background: #fff;width:calc(100% - 165px); margin-left: 4px; display: inline-block;font-weight: 400;margin-top: 1px;border-radius: 3px;" v-model="getbusinessdomain.temp_domain" class="form-control input">.genamet.com</b>                                
        <span class="help is-danger required" v-if="this.err_businessdomain"> Please enter clinic domain</span>
         <span class="help is-danger required" v-if="this.err_duplicate_businessdomain"> Entered clinic domain is already exists, please enter different domain</span>
         </div>
         <div class=" f-width text-left left">
            <label class="check-cust-lbl">              
            I agree to all the <a href="#">terms and conditions</a>
             <input id="chkagree" name="chkagree" type="checkbox" v-model="newstaff.terms_conditions">
           <span class="checkmark">
            </span>
            </label>
         </div>
         <span class="help is-danger required" v-if="this.err_termsconditions"> Please accept terms and conditions</span>
         <div class="form-group f-width text-left left">
            <label class="check-cust-lbl">
            Receive a newsletter from Genamet
            <input id="newsletter" name="chkagree" type="checkbox" v-model="newstaff.news_letter">
            <span class="checkmark">
            </span>
            </label>
         </div>
         <div class="f-width left">
            <button class="btn btn-primary md-button right green-btn" id="btn_subscribe" v-on:click="submit_subscription()">Submit</button>
         </div>
     </div>
   </div>
</div>
</div> -->
  <div class="signin-main subscriptionContent col-12">
    <div class="row">
      <div
        class="col-md-6 col-12 col-lg-6 accountInfoHold order-last order-lg-first order-md-first p-0"
      >
        <div class="image-holder" v-bind:class="{ 'input-visible': !passlen }">
          <div class="password-field">
            <ul>
              <li
                v-bind:class="{
                  'password-valid': hasUpperCaseChar,
                  'password-invalid': !hasUpperCaseChar,
                }"
              >
                At least 1 upper case letter ( A - Z )
              </li>
              <!-- <li class="password-current">At least 1 lower case letter ( a - z )</li> -->
              <li
                v-bind:class="{
                  'password-valid': hasLowerCaseChar,
                  'password-invalid': !hasLowerCaseChar,
                }"
              >
                At least 1 lower case letter ( a - z )
              </li>
              <li
                v-bind:class="{
                  'password-valid': hasNumberChar,
                  'password-invalid': !hasNumberChar,
                }"
              >
                At least 1 numeric character ( 0 - 9 )
              </li>
              <li
                v-bind:class="{
                  'password-valid': hasSpecialChar,
                  'password-invalid': !hasSpecialChar,
                }"
              >
                At least 1 special case character
              </li>
              <li
                v-bind:class="{
                  'password-valid': hasPassLength,
                  'password-invalid': !hasPassLength,
                }"
              >
                At least 8 characters
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-12 col-lg-6">
        <div class="row align-items-center formhold">
          <div class="col-12">
            <div class="signin-container position-relative">
              <div class="spinner_hold" v-if="showloader || isPlanLoading">
                <div class="spinner cover-spin">
                  <div class="bounce1"></div>
                  <div class="bounce2"></div>
                  <div class="bounce3"></div>
                </div>
              </div>
              <div class="signin-hold">
                <a href="https://www.genamet.com/" target="_blank"
                  ><img src="../static/images/logo.png"
                /></a>
                <h1 class="mt-2 mb-2">Account information</h1>
                <div class="mt-3">
                  <div class="form-group signin-icons">
                    <div class="row">
                      <div class="col-md-3 col-4">
                        <div class="select width-100">
                          <select
                            class="select-text sector-select"
                            v-model="newstaff.title"
                          >
                            <option value="Dr">Dr.</option>
                            <option value="Mr">Mr.</option>
                            <option value="Mrs">Mrs.</option>
                            <option value="Miss">Miss.</option>
                          </select>
                          <span class="select-highlight"></span>
                          <span class="select-bar"></span>
                        </div>
                      </div>
                      <div class="col-md-9 col-8 padl-0">
                        <input
                          type="text"
                          autocomplete="off"
                          name="uname"
                          required
                          v-model="newstaff.full_name"
                        />
                        <span
                          class="help is-danger required"
                          v-if="this.err_fullname && !newstaff.full_name"
                        >
                          Please enter full name</span
                        >
                        <span
                          class="help is-danger required"
                          v-if="this.err_name_regex"
                        >
                          Please alphabets Only</span
                        >
                        <label for="uname"><b>Full name</b></label>
                      </div>
                    </div>
                  </div>
                  <div class="form-group signin-icons mart-15">
                    <input
                      type="text"
                      @input="EmailCheck"
                      @blur="userexists(newstaff.email)"
                      required
                      v-model="newstaff.email"
                    />
                    <span
                      class="help is-danger required"
                      v-if="this.err_email && !newstaff.email"
                    >
                      Please enter email address</span
                    >
                    <span
                      class="help is-danger required"
                      v-if="this.err_email_regex"
                    >
                      Please enter valid email address</span
                    >
                    <span
                      class="help is-danger required"
                      v-if="this.err_email_exist"
                    >
                      Your email address already exists.
                      <router-link tag="a" :to="this.portal_link"
                        >click here</router-link
                      >
                      to Sign In</span
                    >
                    <label for="psw"><b>Email address</b></label>
                  </div>
                  <div class="form-group signin-icons mart-15">
                    <input
                      type="password"
                      id="Password"
                      autocomplete="off"
                      @input="enterpassword"
                      required
                      v-model="newstaff.newpass"
                    />
                    <div class="input-visible">
                      <span
                        @click="ShowPassword"
                        v-bind:class="{
                          'sign-up-pass-hidden':
                            !showHideFlag && newstaff.newpass.length > 0,
                          'sign-up-pass-visible':
                            showHideFlag && newstaff.newpass.length > 0,
                        }"
                      ></span>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <span
                          v-show="pwdnotvalid"
                          class="help is-danger required"
                          >Please input a valid password</span
                        >
                        <span
                          v-show="errors.isOldPswdLengthFormatValid"
                          class="help is-danger required"
                          >Maximumm password length reached.<br />It should be
                          between 8 and {{ maxpswdCharLen }}</span
                        >
                      </div>
                    </div>
                    <label for="psw"><b>Password</b></label>
                  </div>
                  <div class="form-group signin-icons mart-15">
                    <div class="row">
                      <div class="col-xl-3  col-lg-4 col-md-5 col-5">
                        <div class="select width-100">
                          <select
                            id="countryPhoneCode"
                            class="select-text sector-select"
                            @change="setCcode"
                            v-model="newstaff.countrycode"
                          >
                            <option data-countrycode="IN" value="91">
                              IN (+91)
                            </option>
                            <option data-countrycode="GB" value="44">
                              GB (+44)
                            </option>
                            <option data-countrycode="US" value="1">
                              US (+1)
                            </option>
                            <optgroup label="Other countries">
                              <option data-countrycode="DZ" value="213">
                                DZ (+213)
                              </option>
                              <option data-countrycode="AD" value="376">
                                AD (+376)
                              </option>
                              <option data-countrycode="AO" value="244">
                                AO (+244)
                              </option>
                              <option data-countrycode="AI" value="1264">
                                AI (+1264)
                              </option>
                              <option data-countrycode="AG" value="1268">
                                AG (+1268)
                              </option>
                              <option data-countrycode="AR" value="54">
                                AR (+54)
                              </option>
                              <option data-countrycode="AM" value="374">
                                AM (+374)
                              </option>
                              <option data-countrycode="AW" value="297">
                                AW (+297)
                              </option>
                              <option data-countrycode="AU" value="61">
                                AU (+61)
                              </option>
                              <option data-countrycode="AT" value="43">
                                AT (+43)
                              </option>
                              <option data-countrycode="AZ" value="994">
                                AZ (+994)
                              </option>
                              <option data-countrycode="BS" value="1242">
                                BS (+1242)
                              </option>
                              <option data-countrycode="BH" value="973">
                                BH (+973)
                              </option>
                              <option data-countrycode="BD" value="880">
                                BD (+880)
                              </option>
                              <option data-countrycode="BB" value="1246">
                                BB (+1246)
                              </option>
                              <option data-countrycode="BY" value="375">
                                BY (+375)
                              </option>
                              <option data-countrycode="BE" value="32">
                                BE (+32)
                              </option>
                              <option data-countrycode="BZ" value="501">
                                BZ (+501)
                              </option>
                              <option data-countrycode="BJ" value="229">
                                BJ (+229)
                              </option>
                              <option data-countrycode="BM" value="1441">
                                BM (+1441)
                              </option>
                              <option data-countrycode="BT" value="975">
                                BT (+975)
                              </option>
                              <option data-countrycode="BO" value="591">
                                BO (+591)
                              </option>
                              <option data-countrycode="BA" value="387">
                                BA (+387)
                              </option>
                              <option data-countrycode="BW" value="267">
                                BW (+267)
                              </option>
                              <option data-countrycode="BR" value="55">
                                BR (+55)
                              </option>
                              <option data-countrycode="BN" value="673">
                                BN (+673)
                              </option>
                              <option data-countrycode="BG" value="359">
                                BG (+359)
                              </option>
                              <option data-countrycode="BF" value="226">
                                BF (+226)
                              </option>
                              <option data-countrycode="BI" value="257">
                                BI (+257)
                              </option>
                              <option data-countrycode="KH" value="855">
                                KH (+855)
                              </option>
                              <option data-countrycode="CM" value="237">
                                CM (+237)
                              </option>
                              <option data-countrycode="CA" value="1">
                                CA (+1)
                              </option>
                              <option data-countrycode="CV" value="238">
                                CV (+238)
                              </option>
                              <option data-countrycode="KY" value="1345">
                                KY (+1345)
                              </option>
                              <option data-countrycode="CF" value="236">
                                CF (+236)
                              </option>
                              <option data-countrycode="CL" value="56">
                                CL (+56)
                              </option>
                              <option data-countrycode="CN" value="86">
                                CN (+86)
                              </option>
                              <option data-countrycode="CO" value="57">
                                CO (+57)
                              </option>
                              <option data-countrycode="KM" value="269">
                                KM (+269)
                              </option>
                              <option data-countrycode="CG" value="242">
                                CG (+242)
                              </option>
                              <option data-countrycode="CK" value="682">
                                CK (+682)
                              </option>
                              <option data-countrycode="CR" value="506">
                                CR (+506)
                              </option>
                              <option data-countrycode="HR" value="385">
                                HR (+385)
                              </option>
                              <option data-countrycode="CU" value="53">
                                CU (+53)
                              </option>
                              <option data-countrycode="CY" value="90392">
                                CY (+90392)
                              </option>
                              <option data-countrycode="CY" value="357">
                                CY (+357)
                              </option>
                              <option data-countrycode="CZ" value="42">
                                CZ (+42)
                              </option>
                              <option data-countrycode="DK" value="45">
                                DK (+45)
                              </option>
                              <option data-countrycode="DJ" value="253">
                                DJ (+253)
                              </option>
                              <option data-countrycode="DM" value="1809">
                                DM (+1809)
                              </option>
                              <option data-countrycode="DO" value="1809">
                                DO (+1809)
                              </option>
                              <option data-countrycode="EC" value="593">
                                EC (+593)
                              </option>
                              <option data-countrycode="EG" value="20">
                                EG (+20)
                              </option>
                              <option data-countrycode="SV" value="503">
                                SV (+503)
                              </option>
                              <option data-countrycode="GQ" value="240">
                                GQ (+240)
                              </option>
                              <option data-countrycode="ER" value="291">
                                ER (+291)
                              </option>
                              <option data-countrycode="EE" value="372">
                                EE (+372)
                              </option>
                              <option data-countrycode="ET" value="251">
                                ET (+251)
                              </option>
                              <option data-countrycode="FK" value="500">
                                FK (+500)
                              </option>
                              <option data-countrycode="FO" value="298">
                                FO (+298)
                              </option>
                              <option data-countrycode="FJ" value="679">
                                FJ (+679)
                              </option>
                              <option data-countrycode="FI" value="358">
                                FI (+358)
                              </option>
                              <option data-countrycode="FR" value="33">
                                FR (+33)
                              </option>
                              <option data-countrycode="GF" value="594">
                                GF (+594)
                              </option>
                              <option data-countrycode="PF" value="689">
                                PF (+689)
                              </option>
                              <option data-countrycode="GA" value="241">
                                GA (+241)
                              </option>
                              <option data-countrycode="GM" value="220">
                                GM (+220)
                              </option>
                              <option data-countrycode="GE" value="7880">
                                GE (+7880)
                              </option>
                              <option data-countrycode="DE" value="49">
                                DE (+49)
                              </option>
                              <option data-countrycode="GH" value="233">
                                GH (+233)
                              </option>
                              <option data-countrycode="GI" value="350">
                                GI (+350)
                              </option>
                              <option data-countrycode="GR" value="30">
                                GR (+30)
                              </option>
                              <option data-countrycode="GL" value="299">
                                GL (+299)
                              </option>
                              <option data-countrycode="GD" value="1473">
                                GD (+1473)
                              </option>
                              <option data-countrycode="GP" value="590">
                                GP (+590)
                              </option>
                              <option data-countrycode="GU" value="671">
                                GU (+671)
                              </option>
                              <option data-countrycode="GT" value="502">
                                GT (+502)
                              </option>
                              <option data-countrycode="GN" value="224">
                                GN (+224)
                              </option>
                              <option data-countrycode="GW" value="245">
                                GW (+245)
                              </option>
                              <option data-countrycode="GY" value="592">
                                GY (+592)
                              </option>
                              <option data-countrycode="HT" value="509">
                                HT (+509)
                              </option>
                              <option data-countrycode="HN" value="504">
                                HN (+504)
                              </option>
                              <option data-countrycode="HK" value="852">
                                HK (+852)
                              </option>
                              <option data-countrycode="HU" value="36">
                                HU (+36)
                              </option>
                              <option data-countrycode="IS" value="354">
                                IS (+354)
                              </option>
                              <option data-countrycode="ID" value="62">
                                ID (+62)
                              </option>
                              <option data-countrycode="IR" value="98">
                                IR (+98)
                              </option>
                              <option data-countrycode="IQ" value="964">
                                IQ (+964)
                              </option>
                              <option data-countrycode="IE" value="353">
                                IE (+353)
                              </option>
                              <option data-countrycode="IL" value="972">
                                IL (+972)
                              </option>
                              <option data-countrycode="IT" value="39">
                                IT (+39)
                              </option>
                              <option data-countrycode="JM" value="1876">
                                JM (+1876)
                              </option>
                              <option data-countrycode="JP" value="81">
                                JP (+81)
                              </option>
                              <option data-countrycode="JO" value="962">
                                JO (+962)
                              </option>
                              <option data-countrycode="KZ" value="7">
                                KZ (+7)
                              </option>
                              <option data-countrycode="KE" value="254">
                                KE (+254)
                              </option>
                              <option data-countrycode="KI" value="686">
                                KI (+686)
                              </option>
                              <option data-countrycode="KP" value="850">
                                KP (+850)
                              </option>
                              <option data-countrycode="KR" value="82">
                                KR (+82)
                              </option>
                              <option data-countrycode="KW" value="965">
                                KW (+965)
                              </option>
                              <option data-countrycode="KG" value="996">
                                KG (+996)
                              </option>
                              <option data-countrycode="LA" value="856">
                                LA (+856)
                              </option>
                              <option data-countrycode="LV" value="371">
                                LV (+371)
                              </option>
                              <option data-countrycode="LB" value="961">
                                LB (+961)
                              </option>
                              <option data-countrycode="LS" value="266">
                                LS (+266)
                              </option>
                              <option data-countrycode="LR" value="231">
                                LR (+231)
                              </option>
                              <option data-countrycode="LY" value="218">
                                LY (+218)
                              </option>
                              <option data-countrycode="LI" value="417">
                                LI (+417)
                              </option>
                              <option data-countrycode="LT" value="370">
                                LT (+370)
                              </option>
                              <option data-countrycode="LU" value="352">
                                LU (+352)
                              </option>
                              <option data-countrycode="MO" value="853">
                                MO (+853)
                              </option>
                              <option data-countrycode="MK" value="389">
                                MK (+389)
                              </option>
                              <option data-countrycode="MG" value="261">
                                MG (+261)
                              </option>
                              <option data-countrycode="MW" value="265">
                                MW (+265)
                              </option>
                              <option data-countrycode="MY" value="60">
                                MY (+60)
                              </option>
                              <option data-countrycode="MV" value="960">
                                MV (+960)
                              </option>
                              <option data-countrycode="ML" value="223">
                                ML (+223)
                              </option>
                              <option data-countrycode="MT" value="356">
                                MT (+356)
                              </option>
                              <option data-countrycode="MH" value="692">
                                MH (+692)
                              </option>
                              <option data-countrycode="MQ" value="596">
                                MQ (+596)
                              </option>
                              <option data-countrycode="MR" value="222">
                                MR (+222)
                              </option>
                              <option data-countrycode="YT" value="269">
                                YT (+269)
                              </option>
                              <option data-countrycode="MX" value="52">
                                MX (+52)
                              </option>
                              <option data-countrycode="FM" value="691">
                                FM (+691)
                              </option>
                              <option data-countrycode="MD" value="373">
                                MD (+373)
                              </option>
                              <option data-countrycode="MC" value="377">
                                MC (+377)
                              </option>
                              <option data-countrycode="MN" value="976">
                                MN (+976)
                              </option>
                              <option data-countrycode="MS" value="1664">
                                MS (+1664)
                              </option>
                              <option data-countrycode="MA" value="212">
                                MA (+212)
                              </option>
                              <option data-countrycode="MZ" value="258">
                                MZ (+258)
                              </option>
                              <option data-countrycode="MN" value="95">
                                MN (+95)
                              </option>
                              <option data-countrycode="NA" value="264">
                                NA (+264)
                              </option>
                              <option data-countrycode="NR" value="674">
                                NR (+674)
                              </option>
                              <option data-countrycode="NP" value="977">
                                NP (+977)
                              </option>
                              <option data-countrycode="NL" value="31">
                                NL (+31)
                              </option>
                              <option data-countrycode="NC" value="687">
                                NC (+687)
                              </option>
                              <option data-countrycode="NZ" value="64">
                                NZ (+64)
                              </option>
                              <option data-countrycode="NI" value="505">
                                NI (+505)
                              </option>
                              <option data-countrycode="NE" value="227">
                                NE (+227)
                              </option>
                              <option data-countrycode="NG" value="234">
                                NG (+234)
                              </option>
                              <option data-countrycode="NU" value="683">
                                NU (+683)
                              </option>
                              <option data-countrycode="NF" value="672">
                                NF (+672)
                              </option>
                              <option data-countrycode="NP" value="670">
                                NP (+670)
                              </option>
                              <option data-countrycode="NO" value="47">
                                NO (+47)
                              </option>
                              <option data-countrycode="OM" value="968">
                                OM (+968)
                              </option>
                              <option data-countrycode="PW" value="680">
                                PW (+680)
                              </option>
                              <option data-countrycode="PA" value="507">
                                PA (+507)
                              </option>
                              <option data-countrycode="PG" value="675">
                                PG (+675)
                              </option>
                              <option data-countrycode="PY" value="595">
                                PY (+595)
                              </option>
                              <option data-countrycode="PE" value="51">
                                PE (+51)
                              </option>
                              <option data-countrycode="PH" value="63">
                                PH (+63)
                              </option>
                              <option data-countrycode="PL" value="48">
                                PL (+48)
                              </option>
                              <option data-countrycode="PT" value="351">
                                PT (+351)
                              </option>
                              <option data-countrycode="PR" value="1787">
                                PR (+1787)
                              </option>
                              <option data-countrycode="QA" value="974">
                                QA (+974)
                              </option>
                              <option data-countrycode="RE" value="262">
                                RE (+262)
                              </option>
                              <option data-countrycode="RO" value="40">
                                RO (+40)
                              </option>
                              <option data-countrycode="RU" value="7">
                                RU (+7)
                              </option>
                              <option data-countrycode="RW" value="250">
                                RW (+250)
                              </option>
                              <option data-countrycode="SM" value="378">
                                SM (+378)
                              </option>
                              <option data-countrycode="ST" value="239">
                                ST (+239)
                              </option>
                              <option data-countrycode="SA" value="966">
                                SA (+966)
                              </option>
                              <option data-countrycode="SN" value="221">
                                SN (+221)
                              </option>
                              <option data-countrycode="CS" value="381">
                                CS (+381)
                              </option>
                              <option data-countrycode="SC" value="248">
                                SC (+248)
                              </option>
                              <option data-countrycode="SL" value="232">
                                SL (+232)
                              </option>
                              <option data-countrycode="SG" value="65">
                                SG (+65)
                              </option>
                              <option data-countrycode="SK" value="421">
                                SK (+421)
                              </option>
                              <option data-countrycode="SI" value="386">
                                SI (+386)
                              </option>
                              <option data-countrycode="SB" value="677">
                                SB (+677)
                              </option>
                              <option data-countrycode="SO" value="252">
                                SO (+252)
                              </option>
                              <option data-countrycode="ZA" value="27">
                                ZA (+27)
                              </option>
                              <option data-countrycode="ES" value="34">
                                ES (+34)
                              </option>
                              <option data-countrycode="LK" value="94">
                                LK (+94)
                              </option>
                              <option data-countrycode="SH" value="290">
                                SH (+290)
                              </option>
                              <option data-countrycode="KN" value="1869">
                                KN (+1869)
                              </option>
                              <option data-countrycode="SC" value="1758">
                                SC (+1758)
                              </option>
                              <option data-countrycode="SD" value="249">
                                SD (+249)
                              </option>
                              <option data-countrycode="SR" value="597">
                                SR (+597)
                              </option>
                              <option data-countrycode="SZ" value="268">
                                SZ (+268)
                              </option>
                              <option data-countrycode="SE" value="46">
                                SE (+46)
                              </option>
                              <option data-countrycode="CH" value="41">
                                CH (+41)
                              </option>
                              <option data-countrycode="SI" value="963">
                                SI (+963)
                              </option>
                              <option data-countrycode="TW" value="886">
                                TW (+886)
                              </option>
                              <option data-countrycode="TJ" value="7">
                                TJ (+7)
                              </option>
                              <option data-countrycode="TH" value="66">
                                TH (+66)
                              </option>
                              <option data-countrycode="TG" value="228">
                                TG (+228)
                              </option>
                              <option data-countrycode="TO" value="676">
                                TO (+676)
                              </option>
                              <option data-countrycode="TT" value="1868">
                                TT (+1868)
                              </option>
                              <option data-countrycode="TN" value="216">
                                TN (+216)
                              </option>
                              <option data-countrycode="TR" value="90">
                                TR (+90)
                              </option>
                              <option data-countrycode="TM" value="7">
                                TM (+7)
                              </option>
                              <option data-countrycode="TM" value="993">
                                TM (+993)
                              </option>
                              <option data-countrycode="TC" value="1649">
                                TC (+1649)
                              </option>
                              <option data-countrycode="TV" value="688">
                                TV (+688)
                              </option>
                              <option data-countrycode="UG" value="256">
                                UG (+256)
                              </option>
                              <option data-countrycode="UA" value="380">
                                UA (+380)
                              </option>
                              <option data-countrycode="AE" value="971">
                                AE (+971)
                              </option>
                              <option data-countrycode="UY" value="598">
                                UY (+598)
                              </option>
                              <option data-countrycode="UZ" value="7">
                                UZ (+7)
                              </option>
                              <option data-countrycode="VU" value="678">
                                VU (+678)
                              </option>
                              <option data-countrycode="VA" value="379">
                                VA (+379)
                              </option>
                              <option data-countrycode="VE" value="58">
                                VE (+58)
                              </option>
                              <option data-countrycode="VN" value="84">
                                VN (+84)
                              </option>
                              <option data-countrycode="VG" value="84">
                                VG (+1284)
                              </option>
                              <option data-countrycode="VI" value="84">
                                VI (+1340)
                              </option>
                              <option data-countrycode="WF" value="681">
                                WF (+681)
                              </option>
                              <option data-countrycode="YE" value="969">
                                YE(+969)
                              </option>
                              <option data-countrycode="YE" value="967">
                                YE(+967)
                              </option>
                              <option data-countrycode="ZM" value="260">
                                ZM (+260)
                              </option>
                              <option data-countrycode="ZW" value="263">
                                ZW (+263)
                              </option>
                            </optgroup>
                          </select>
                          <span class="select-highlight"></span>
                          <span class="select-bar"></span>
                        </div>
                      </div>
                      <div class="col-xl-9 col-lg-8 col-md-7 col-7 padl-0">
                        <input
                          type="text"
                          maxlength="15"
                          @input="PhoneCheck"
                          v-model="newstaff.mobile"
                          autocomplete="off"
                          name="uname"
                          required
                        />
                        <span
                          class="help is-danger required"
                          v-if="this.err_mobile && !newstaff.mobile"
                        >
                          Please enter mobile number</span
                        >
                        <span
                          class="help is-danger required"
                          v-if="this.err_mobile_regex"
                        >
                          Please enter valid mobile number</span
                        >
                        <label for="uname"><b>Mobile number</b></label>
                      </div>
                    </div>
                  </div>
                  <div class="form-group signin-icons mart-15">
                    <input
                      type="text"
                      required
                      maxlength="50"
                      v-model="newstaff.business_name"
                    />
                    <span
                      class="help is-danger required"
                      v-if="this.err_businessname && !newstaff.business_name"
                    >
                      Please enter clinic name</span
                    >
                    <label for="psw"><b>Clinic name</b></label>
                  </div>

                  <!-- <div class="mt-4" v-show="browser_country == 'IN'">
                    <div class="address-section">
                      <h4 class="mt-5 mb-4 text-left">Billing Address</h4>
                      <div class="form-group">
                        <div class="row">
                          <div class="col-md-6">
                            <div class="p-relative">
                              <input
                                type="text"
                                name="flat"
                                v-model="newstaff.flat_house_no"
                                required
                              />
                              <span
                                class="help is-danger required"
                                v-if="err_flat && !newstaff.flat_house_no"
                              >
                                Please enter flat no.
                              </span>
                              <label for="flat">
                                <b>Flat House No <em>*</em></b>
                              </label>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="p-relative">
                              <input
                                type="text"
                                name="area"
                                v-model="newstaff.area_street"
                                required
                              />
                              <label for="area">
                                <b>Area, Street</b>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="row">
                          <div class="col-md-6">
                            <div class="p-relative">
                              <input
                                type="text"
                                autocomplete="off"
                                name="town"
                                v-model="newstaff.city"
                                required="required"
                              />
                              <span
                                class="help is-danger required"
                                v-if="err_city && !newstaff.city"
                              >
                                Please enter city
                              </span>
                              <label for="town">
                                <b>Town/City <em>*</em></b>
                              </label>
                            </div>
                          </div>
                          
                          <div class="col-md-6">
                            <div class="select width-100" style="height:auto;">
                              <country-select
                                v-model="newstaff.country"
                                :country="newstaff.country"
                                topCountry="IN"
                                :countryName="true"
                              />
                            </div>
                            <span
                                class="help is-danger required"
                                v-if="err_country && !newstaff.country"
                              >
                                Please select country
                              </span>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="row">
                          <div class="col-md-6">
                            <div class="p-relative">
                              <input
                                type="text"
                                name="pincode"
                                v-model="newstaff.pincode"
                                required="required"
                              />
                              <span
                                class="help is-danger required"
                                v-if="err_pincode && !newstaff.pincode"
                              >
                                Please enter pincode
                              </span>
                              <label for="address-1">
                                <b>Pincode <em>*</em></b>
                              </label>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="select width-100" style="height:auto;">
                              <region-select
                                v-model="newstaff.state"
                                :country="newstaff.country"
                                :region="region"
                                :countryName="true"
                                :regionName="true"
                              />

                              
                            </div>
                            <span
                                class="help is-danger required"
                                v-if="err_region && !newstaff.state"
                              >
                                Please select region
                              </span>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <div class="row">
                          <div class="col-md-6">
                            <label
                              data-toggle="tooltip"
                              data-placement="top"
                              title="GSTIN"
                              class="container customcheck mart-10 text-left"
                              data-original-title="GST Identification Number (If available)"
                            >
                              GST Identification Number (If available)
                              <input
                                type="checkbox"
                                id="gstCheckbox"
                                value=""
                                v-model="customer_gst_checkbox"
                              /><span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="col-md-6">
                            <div class="p-relative">
                              <input
                                name="gst"
                                id="gstInput"
                                v-show="customer_gst_checkbox"
                                v-model="newstaff.customer_gst_number"
                                type="text"
                                placeholder="GSTIN"
                              />

                              <label v-if="customer_gst_checkbox" for="gst" id="gstLabel">GSTIN </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> -->

                  <div
                    class="form-group signin-icons website-grey-box mart-15"
                    style="display: none"
                  >
                    <span>https://</span>
                    <input
                      type="text"
                      disabled
                      style="background-color: #f1f1f1"
                      name="website"
                      v-model="getbusinessdomain.temp_domain"
                    />
                    <span>.genamet.com</span>
                    <span
                      class="help is-danger required"
                      v-if="this.err_businessdomain"
                      style="padding-left: 50px"
                    >
                      Please enter clinic domain</span
                    >
                    <span
                      class="help is-danger required"
                      v-if="this.err_duplicate_businessdomain"
                    >
                      Entered clinic domain is already exists, please enter
                      different domain</span
                    >
                  </div>
                  <div class="form-group signin-icons">
                    <label
                      data-toggle="tooltip"
                      data-placement="top"
                      title=""
                      class="container customcheck mart-10"
                    >
                      I agree to receiving regular updates from Genamet
                      <input type="checkbox" v-model="newstaff.news_letter" />
                      <span class="checkmark"></span>
                    </label>
                    <label
                      data-toggle="tooltip"
                      data-placement="top"
                      title=""
                      class="container customcheck mart-10"
                    >
                      I agree to all the
                      <span class="termsColor" @click="termsNConditionsPopup()"
                        >terms and conditions</span
                      >
                      <input
                        type="checkbox"
                        v-model="newstaff.terms_conditions"
                      />
                      <span class="checkmark"></span>
                    </label>
                    <span
                      class="help is-danger required"
                      v-if="
                        this.err_termsconditions && !newstaff.terms_conditions
                      "
                      style="padding-left: 22px"
                    >
                      Please accept terms and conditions</span
                    >
                  </div>
                </div>
                <div class="signin-btn-hold mt-2">
                  <a
                    href="javascript:void(0)"
                    v-bind:class="{
                      'global-disabled': !newstaff.terms_conditions,
                    }"
                    class="primary-btn ripple pull-right signin-btn"
                    id="btn_subscribe"
                    v-on:click="submit_subscription()"
                    >Submit</a
                  >
                  <!-- <button class="btn btn-primary md-button right green-btn" id="btn_subscribe" v-on:click="submit_subscription()">Submit</button> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <TermsAndConditions
                  ref="confirmcomp"
                  :showmodal="showCancelPopUp"
                    @close="close" 
                    v-if="showTermsandConditionsPopup"
                  
                >    </TermsAndConditions>   -->
    <TermsAndConditions
      ref="confirmcomp"
      :showmodal="showCnfrmPopUp"
      @cancelAction="
        showCnfrmPopUp = false;
        confrmPopUpResponse = false;
      "
      @confirmAction="
        showCnfrmPopUp = false;
        confrmPopUpResponse = true;
      "
    >
    </TermsAndConditions>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import CountryCode from "../model/country_code";
import TermsAndConditions from "@/components/TermsAndConditions.vue";
import vueCountryRegionSelect from "vue-country-region-select";
Vue.use(vueCountryRegionSelect);

var tenantsubsurl = "/tenantsubscription";
var country_code = CountryCode.country_code;
export default {
  name: "subscribe",
  components: {
    TermsAndConditions,
  },
  data: function () {
    return {
      customer_gst_number: "",
      customer_gst_checkbox: false,
      browser_country: "IN",
      country: "",
      region: "",
      flat: "",
      pincode: "",
      city: "",
      region: "",
      area_street: "",
      showCnfrmPopUp: false,
      showPopup: false,
      currentDateTime: "",
      newstaff: {},
      showHideFlag: false,
      err_fullname: false,
      err_email: false,
      err_mobile: false,
      err_businessname: false,
      err_businessdomain: false,
      err_termsconditions: false,
      err_duplicate_businessdomain: false,
      err_name_regex: false,
      err_email_regex: false,
      err_email_exist: false,
      err_mobile_regex: false,
      err_country: false,
      err_flat: false,
      err_city: false,
      err_region: false,
      err_pincode: false,
      err_region: "",
      errors: [],
      axioserror: "",
      hasLowerCaseChar: false,
      hasUpperCaseChar: false,
      hasSpecialChar: false,
      hasPassLength: false,
      subscription_details: null,
      session_storage: {},
      country_code,
      showloader: false,
      subsidresponse: {},
      planlist: [],
      portal_link: null,
      isPlanLoading: false,
      newpass: "",
      showPass: false,
      pswdRegEx: /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*\W).{8,10}/,
      maxpswdCharLen: 50,
      pswdValidationResult: false,
      passlen: false,
      showTermsandConditionsPopup: false,
    };
  },
  mounted() {
    this.getCountry();
    localStorage.removeItem("redirect");
    this.newstaff = {
      title: "Dr",
      full_name: "",
      email: "",
      mobile: "",
      business_name: "",
      business_domain: "",
      terms_conditions: false,
      news_letter: true,
      temp_domain: "",
      countrycode: "91",
      newpass: "",
      country: "",
      state: "",
      flat_house_no: "",
      city: "",
      pincode: "",
      area_street: "",
    };

    // debugger;
    var uniqueid = this.$route.params.id;
    var providercount = 1;
    if (this.$route.params.providercount) {
      providercount = this.$route.params.providercount;
    }

    if (!sessionStorage.getItem(uniqueid)) {
      sessionStorage.clear();
      this.isPlanLoading = true;
      var self = this;

      axios
        .get(process.env.VUE_APP_BASEURL + "/subscriptionpackage")
        .then((response) => {
          self.planlist = response.data.result;

          var item = self.planlist.find(
            (p) => p.unique_id == self.$route.params.id
          );
          var uniqueid = this.guid();
          item.no_of_providers = providercount;
          var selected_plan = item;
          var sessionvariables = {};
          sessionvariables.selected_plan = selected_plan;
          sessionStorage.setItem(uniqueid, JSON.stringify(sessionvariables));
          this.$router.replace({
            name: "subscribe",
            params: { id: uniqueid },
            replace: true,
          });

          self.isPlanLoading = false;
          self.loadData();
        })
        .catch((error) => {
          self.axioserror = error;
          self.isPlanLoading = false;
        });
    } else {
      this.loadData();
    }
  },
  computed: {
    getbusinessdomain() {
      var self = this;
      if (self.newstaff.business_name) {
        self.newstaff.business_name = self.newstaff.business_name.replace(
          /[/@`&#,!+(%)$~.'":*?^<>{}[\]]/g,
          ""
        );
        var str = self.newstaff.business_name;
        str = str.replace(/\s+/g, "-").toLowerCase();
        str = str.replace(/[/@`&#,!+(%)$~.'":*?^<>{}[\]]/g, "");
        self.newstaff.temp_domain =
          str.replace(/^-+|-+$/g, "") + this.currentDateTime;
      }
      return self.newstaff;
    },
  },
  methods: {
    getCountry() {
      var self = this;
      // debugger;
      this.browser_country = "IN";
      let urlip =
        "https://api.ipgeolocation.io/ipgeo?apiKey=a86929715b35444b916015f1f1112bac";

      var config = {
        method: "get",
        url: "https://api.ipify.org/?format=json",
      };
      axios(config)
        .then(function (response) {
          // debugger;
          if (response && response.data && response.data.ip) {
            console.log("IP=>", JSON.stringify(response.data));
            //url = url+response.data.ip;
            let cnfg = {
              method: "get",
              url: urlip + "&ip=" + response.data.ip,
            };

            axios(cnfg)
              .then((response) => {
                debugger;
                if (
                  response &&
                  response.data &&
                  (response.data.countryCode || response.data.country_code2)
                ) {
                  if (response.data.country_code2) {
                    debugger;
                    self.browser_country = response.data.country_code2;
                    self.newstaff.countrycode = Number(
                      response.data.calling_code
                    );
                  }
                }
              })
              .catch((e) => {
                console.log("Could not detect any country!", e);
              });
          }
        })
        .catch(function (error) {
          console.log("could not get the ip", error);
        });
    },
    showPopup2() {
      // debugger;
      this.showPopup = true;
    },
    setCcode($event) {
      this.newstaff.countrycode = $event.target.value;
      //this.formattedCountryCode = "+" + this.countrycode.trim();
    },
    termsNConditionsPopup() {
      // debugger;
      this.showCnfrmPopUp = true;
      // this.showTermsandConditionsPopup = true;
      //      document.body.classList.add("modal-mask-open");
    },
    enterpassword() {
      if (this.newstaff.newpass == "") {
        this.passlen = false;
      } else {
        this.passlen = true;
      }
    },
    EmailCheck($event) {
      if (!this.validateEmail(this.newstaff.email)) {
        this.err_email_regex = true;
        this.err_email_exist = false;
      } else {
        this.err_email_regex = false;
      }
    },
    ShowPassword() {
      var typ = document.getElementById("Password").getAttribute("type");
      if (typ === "password") {
        //$('#Password').get(0).type = 'text';
        //$('.signin-pass-visible').show();
        //$('.signin-pass-hidden').hide();
        document.getElementById("Password").setAttribute("type", "text");
        this.showHideFlag = !this.showHideFlag;
      } else {
        // $('#Password').get(0).type = 'password';
        // $('.signin-pass-visible').hide();
        // $('.signin-pass-hidden').show();
        document.getElementById("Password").setAttribute("type", "password");
        this.showHideFlag = !this.showHideFlag;
      }
    },
    userexists(val) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      this.errors = [];
      if (val && val.length > 0) {
        this.checkIsstaffexists = false;
        if (re.test(val.toLowerCase())) {
          this.$cognitoAuth.signup(val, val, "123", "", "", (err, result) => {
            if (err) {
              console.log(err);
              if (err.code == "UsernameExistsException") {
                this.portal_link = "/redirectpageifexist/" + val;
                this.err_email_exist = true;
              } else {
                this.err_email_exist = false;
              }
            }
          });
          //console.log("BEFORE CHECKING STAFF REGISTRATION STATUS>>>",moment().format("HH mm ss"));
        } else {
          this.err_email_regex = true;
        }
      }
    },
    PhoneCheck() {
      if (!this.validateMobile(this.newstaff.mobile)) {
        this.err_mobile_regex = true;
      } else {
        this.err_mobile_regex = false;
      }
    },
    loadData() {
      var uniqueid = this.$route.params.id;
      this.session_storage = JSON.parse(sessionStorage.getItem(uniqueid));
      var selectedplan = this.session_storage.selected_plan;
      if (selectedplan != null && selectedplan.cost_inr != 0) {
        if (selectedplan.validity == "monthly" && selectedplan.razorPlan) {
          var billingcycles = Math.floor(
            parseInt(process.env.VUE_APP_SUBSCRIPTION_MONTHLY_CYCLE_COUNT) /
              selectedplan.razorPlan.interval
          ); //selectedplan.interval
          selectedplan.razorPlan.total_count = billingcycles; //process.env.VUE_APP_SUBSCRIPTION_MONTHLY_CYCLE_COUNT;
        } else {
          selectedplan.razorPlan.total_count =
            process.env.VUE_APP_SUBSCRIPTION_YEARLY_CYCLE_COUNT;
        }
        selectedplan.razorPlan.customer_notify = 1;
        selectedplan.razorPlan.quantity =
          this.session_storage.selected_plan.no_of_providers;
        // axios
        //   .post(
        //     process.env.VUE_APP_BASEURL +
        //       tenantsubsurl +
        //       "/generatesubscriptionid",
        //     selectedplan.razorPlan
        //   )
        //   .then(response => {
        //     //this.showcheckoutform(response.data);
        //     this.showloader = false;
        //     this.subsidresponse = response.data;
        //     })
        //   .catch(error => {this.axioserror = error;
        //     this.showloader = false;
        //   });
      }

      var d = new Date();
      this.currentDateTime =
        "-" +
        ("0" + d.getDate()).slice(-2).toString() +
        ("0" + (d.getMonth() + 1)).slice(-2).toString() +
        d.getFullYear().toString().substr(-2) +
        ("0" + d.getHours().toString()).slice(-2).toString() +
        ("0" + d.getMinutes().toString()).slice(-2).toString();
    },

    guid() {
      return (
        this.s4() +
        this.s4() +
        "-" +
        this.s4() +
        "-" +
        this.s4() +
        "-" +
        this.s4() +
        "-" +
        this.s4() +
        this.s4() +
        this.s4()
      );
    },
    s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    },

    async submit_subscription() {
       localStorage.removeItem("redirect");
      this.errors = [];
      this.err_fullname = false;
      this.err_email = false;
      this.err_mobile = false;
      this.err_businessname = false;
      this.err_businessdomain = false;
      this.err_termsconditions = false;
      this.err_duplicate_businessdomain = false;
      this.err_name_regex = false;
      this.err_email_regex = false;
      this.err_mobile_regex = false;
      this.err_country = false;
      this.err_flat = false;

      if (this.err_email_exist) {
        this.errors.push("Email already exists");
      }
      if(this.newstaff.newpass==''){
        this.pwdnotvalid = true;
      }

      if (this.newstaff.full_name == null || this.newstaff.full_name == "") {
        this.err_fullname = true;
        this.errors.push("Please enter full name");
      } else if (!this.validateName(this.newstaff.full_name)) {
        this.errors.push("Only alphabets and spaces are allowed.");
        this.err_fullname = false;
        this.err_name_regex = true;
      }
      if (this.newstaff.email == null || this.newstaff.email == "") {
        this.err_email = true;
        this.errors.push("Please enter email address");
      } else if (!this.validateEmail(this.newstaff.email)) {
        this.errors.push("Email should be in correct format.");
        this.err_email = false;
        this.err_email_regex = true;
      }
      if (this.newstaff.mobile == null || this.newstaff.mobile == "") {
        this.err_mobile = true;
        this.errors.push("Please enter mobile number");
      } else if (!this.validateMobile(this.newstaff.mobile)) {
        this.errors.push("Mobile number should be of 10 digits.");
        this.err_mobile = false;
        this.err_mobile_regex = true;
      }
      if (
        this.newstaff.business_name == null ||
        this.newstaff.business_name == ""
      ) {
        this.err_businessname = true;
        this.errors.push("Please enter clinic name");
      }

      // if (this.browser_country === "IN") {
      //   if (this.newstaff.country == "" || this.newstaff.country == null) {
      //     this.err_country = true;
      //     this.errors.push("Please select country")
      //   } else {
      //     this.err_country = false;
      //     // this.new_staff['country'] = this.country;
      //   }

      //   if (
      //     this.newstaff.flat_house_no == "" ||
      //     this.newstaff.flat_house_no == null
      //   ) {
      //     this.err_flat = true;
      //     this.errors.push("Please enter flat no.")

      //   } else {
      //     this.err_flat = false;
      //     // this.new_staff.flat_house_no = this.flat;
      //   }

      //   if (this.newstaff.pincode == "" || this.newstaff.pincode == null) {
      //     this.err_pincode = true;
      //     this.errors.push("Please enter pincode")

      //   } else {
      //     this.err_pincode = false;
      //     // this.new_staff.pincode = this.pincode
      //   }

      //   if (this.newstaff.city == "" || this.newstaff.city == null) {
      //     this.err_city = true;
      //     this.errors.push("Please enter city")
      //   } else {
      //     this.err_city = false;
      //     // this.new_staff.towncity = this.city;
      //   }

      //   if (this.newstaff.state == "" || this.newstaff.state == null) {
      //     this.err_region = true;
      //     this.errors.push("Please select state")

      //   } else {
      //     this.err_region = false;
      //     // this.new_staff.state = this.region;
      //   }
      //   //  this.new_staff.area_street = this.area_street;
      // }

      if (this.newstaff.terms_conditions == false) {
        this.err_termsconditions = true;
        this.errors.push("Please accept terms and conditions");
      }
      if (
        this.newstaff.temp_domain == null ||
        this.newstaff.temp_domain == ""
      ) {
        this.err_businessdomain = true;
        this.errors.push("Please enter clinic domain");
      } else {
        if (this.errors.length == 0 && !this.pwdnotvalid) {
          this.showloader = true;
          var url = this.newstaff.temp_domain;
          let config = {
            headers: {
              "Content-Type": "application/json",
            },
          };
          await axios
            .post(
              process.env.VUE_APP_BASEURL + tenantsubsurl + "/checktenant",
              JSON.stringify(url),
              config
            )
            .then((response) => {
              if (response.data) {
                this.showloader = false;
                this.err_businessdomain = false;
                this.err_duplicate_businessdomain = true;
                this.errors.push(
                  "Entered clinic domain is already exists, please enter another domain"
                );
              }
            })
            .catch((error) => {
              this.axioserror = error;
              this.showloader = false;
            });
        }
        this.$cognitoAuth.signup(
          this.newstaff.email,
          this.newstaff.email,
          this.newstaff.newpass,
          "",
          "",
          (err, result) => {
            if (err) {
              console.log(err);
            } else {
              console.log(result);
            }
          }
        );
      }
      if (this.errors.length == 0 && !this.pwdnotvalid) {
        var uniqueid = this.$route.params.id;
        var nmarr = this.newstaff.full_name.split(" ");
        let fullnm = "";
        for (let i = 0; i < nmarr.length; i++) {
          nmarr[i] = nmarr[i] ? nmarr[i].trim() : "";
          if (nmarr[i]) {
            fullnm = (fullnm ? fullnm + " " : "") + nmarr[i];
          }
        }
        this.newstaff.full_name = fullnm;
        this.newstaff.business_domain =
          this.newstaff.temp_domain + ".genamet.com";
        this.session_storage.new_staff = this.newstaff;
        sessionStorage.setItem(uniqueid, JSON.stringify(this.session_storage));
        //commenting to remove razor pay option
        // if (this.session_storage.selected_plan.cost_inr == "0") {
        this.showloader = true;
        var subscriptionobject = JSON.parse(sessionStorage.getItem(uniqueid));
        axios
          //.post(process.env.VUE_APP_BASEURL + tenantsubsurl + "/postsubscription",subscriptionobject)
          .post(
            process.env.VUE_APP_BASEURL + tenantsubsurl + "/tenantsetup",
            subscriptionobject
          )
          .then((response) => {
            this.showloader = false;
            if (response.status == 200) {
                //this.$router.push({ name: "redirectpage" });
              localStorage.setItem("redirect",response.data);
              window.location.replace(response.data);
            }
          })
          .catch((error) => {
             this.$router.push({ name: "errorredirectpage" });
            this.axioserror = error;
            this.showloader = false;
          });
        this.$router.push({ name: "redirectpage" });
        //commenting to remove razor pay option
        // } else {
        //   this.showloader = true;
        //   var selectedplan = this.session_storage.selected_plan;
        //   if (selectedplan.validity == "monthly" && selectedplan.razorPlan) {
        //     var billingcycles = Math.floor(parseInt(process.env.VUE_APP_SUBSCRIPTION_MONTHLY_CYCLE_COUNT)/parseInt(selectedplan.razorPlan.interval));//selectedplan.interval
        //     selectedplan.razorPlan.total_count = billingcycles;//process.env.VUE_APP_SUBSCRIPTION_MONTHLY_CYCLE_COUNT;
        //   }else{
        //     selectedplan.razorPlan.total_count = process.env.VUE_APP_SUBSCRIPTION_YEARLY_CYCLE_COUNT;
        //   }
        //   selectedplan.razorPlan.customer_notify = 1;
        //   selectedplan.razorPlan.quantity = this.session_storage.selected_plan.no_of_providers;

        //   if (selectedplan != null && selectedplan.cost_inr != 0) {

        // this.showcheckoutform(this.subsidresponse);
        // axios
        //   .post(
        //     process.env.VUE_APP_BASEURL +
        //       tenantsubsurl +
        //       "/generatesubscriptionid",
        //     selectedplan.razorPlan
        //   )
        //   .then(response => {
        //     this.showcheckoutform(response.data);
        //     this.showloader = false;
        //     })
        //   .catch(error => {this.axioserror = error;
        //     this.showloader = false;
        //   });
        //     }
        //   }
        // }
        // else{
        //   this.showloader = false;
        // }
      }
    },
    // showcheckoutform(subscriptiondetails) {
    //   var self = this;
    //   var secret = process.env.VUE_APP_RAZORKEY_SECRET; //"MtpKtFbAoz9p286RKvRmokkB";  //process.env.VUE_APP_RAZORKEY_SECRET;
    //   var uniqueid = this.$route.params.id;
    //   this.session_storage.subscriptoin_details = subscriptiondetails;
    //   sessionStorage.setItem(uniqueid, JSON.stringify(this.session_storage));

    //   var options = {
    //     key: process.env.VUE_APP_RAZORKEY, //"rzp_test_TqlGCH4C0ZHRll",  //process.env.VUE_APP_RAZORKEY,
    //     subscription_id: subscriptiondetails.id,
    //     name: "Genamet Subscription",
    //     description:
    //       "Purchased " +
    //       this.session_storage.selected_plan.no_of_providers +
    //       " user licence(s)" +
    //       " for " + this.session_storage.selected_plan.subscriptionPlan.period + " subscription",
    //     handler: function(response) {
    //       var hash = CryptoJS.HmacSHA256(
    //         response.razorpay_payment_id + "|" + subscriptiondetails.id,
    //         secret
    //       ); //creating HMAC signature to authenticate payment
    //       //var hashInBase64 = CryptoJS.enc.Base64.stringify(hash);
    //       var expectedSignature = hash.toString();
    //       if (expectedSignature == response.razorpay_signature) {
    //         self.showloader = true;
    //         self.session_storage.subscription_response = response;
    //         sessionStorage.setItem(
    //           uniqueid,
    //           JSON.stringify(self.session_storage)
    //         );
    //         // alert("signature matched.. " + response.razorpay_payment_id);
    //         var subscriptionobject = JSON.parse(
    //           sessionStorage.getItem(uniqueid)
    //         );
    //         //axios
    //           // .post(
    //           //   process.env.VUE_APP_BASEURL +
    //           //     tenantsubsurl +
    //           //     "/postsubscription",
    //           //   subscriptionobject
    //           // )
    //           axios
    //           .post(
    //             process.env.VUE_APP_BASEURL +
    //               tenantsubsurl +
    //               "/tenantsetup",
    //             subscriptionobject
    //           )
    //           .then(response => {
    //             if (response.status == 201) {
    //               self.showloader = false;
    //               self.$router.push({ name: "redirectpage" });
    //             }
    //           })
    //           .catch(error => {
    //             self.axioserror = error;
    //             self.showloader = false;
    //           });
    //       } else {
    //         self.axioserror = "Razor signature does not match";
    //         self.showloader = false;
    //       }
    //     },
    //     modal: {
    //       ondismiss: function(){
    //         self.showloader = false;
    //       }
    //     },
    //     prefill: {
    //       email: self.newstaff.email,
    //       contact: "+" + self.newstaff.countrycode + self.newstaff.mobile
    //     }
    //   };
    //   var rzp1 = new Razorpay(options);
    //   rzp1.open();
    // },
    validateName: function (name) {
      var re = /^[A-Za-z ]+$/;
      var re2 = re.test(name);
      return re2;
    },
    validateEmail: function (email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var re2 = re.test(email);
      return re2;
    },
    validateMobile: function (mobile) {
      var re = /^\d{10}$/;
      var re2 = re.test(mobile);
      return re2;
    },
  },
  watch: {
    "newstaff.newpass": {
      handler: function (val, oldval) {
        var format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
        var numericformat = /[0-9]/;
        if (val) {
          if (val.toUpperCase() != val) {
            this.hasLowerCaseChar = true;
          } else {
            this.hasLowerCaseChar = false;
          }
          if (val.toLowerCase() != val) {
            this.hasUpperCaseChar = true;
          } else {
            this.hasUpperCaseChar = false;
          }
          if (numericformat.test(val)) {
            this.hasNumberChar = true;
          } else {
            this.hasNumberChar = false;
          }
          if (format.test(val)) {
            this.hasSpecialChar = true;
          } else {
            this.hasSpecialChar = false;
          }
          if (val.length >= 8) {
            this.hasPassLength = true;
          } else {
            this.hasPassLength = false;
          }

          if (
            this.hasLowerCaseChar &&
            this.hasUpperCaseChar &&
            this.hasNumberChar &&
            this.hasSpecialChar &&
            this.hasPassLength
          ) {
            if (val.length <= this.maxpswdCharLen) {
              if (val.length < this.maxpswdCharLen) {
                delete this.errors.isOldPswdLengthFormatValid;
                this.pwdnotvalid = false;
              }
              delete this.errors.isOldPswdFormatValid;
              this.pwdnotvalid = false;
            } else {
              //this.newpass = oldval;
              this.errors.isOldPswdLengthFormatValid = true;
              this.pwdnotvalid = true;
            }
            this.pswdValidationResult = true;
          } else {
            this.pswdValidationResult = false;
            this.errors.isOldPswdFormatValid = true;
            this.pwdnotvalid = true;
          }
        } else {
          this.hasLowerCaseChar = false;
          this.hasUpperCaseChar = false;
          this.hasNumberChar = false;
          this.hasSpecialChar = false;
          this.hasPassLength = false;
          this.pswdValidationResult = false;
          delete this.errors.isOldPswdLengthFormatValid;
          delete this.errors.isOldPswdFormatValid;
          this.pwdnotvalid = false;
        }
      },
    },

    // newpass: function(val, oldval) {
    //   var format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
    //   var numericformat = /[0-9]/;
    //   if(val){
    //     if (val.toUpperCase() != val) {
    //       this.hasLowerCaseChar = true;
    //     }else{
    //       this.hasLowerCaseChar = false;
    //     }
    //     if (val.toLowerCase() != val) {
    //       this.hasUpperCaseChar = true;
    //     }else{
    //       this.hasUpperCaseChar = false;
    //     }
    //     if (numericformat.test(val)) {
    //       this.hasNumberChar = true;
    //     }else{
    //       this.hasNumberChar = false;
    //     }
    //     if (format.test(val)) {
    //       this.hasSpecialChar = true;
    //     }else{
    //       this.hasSpecialChar = false;
    //     }
    //     if (val.length >= 8) {
    //       this.hasPassLength = true;
    //     }else{
    //       this.hasPassLength = false;
    //     }

    //     if(this.hasLowerCaseChar && this.hasUpperCaseChar && this.hasNumberChar && this.hasSpecialChar && this.hasPassLength)
    //     {
    //       if(val.length<=this.maxpswdCharLen){
    //         if(val.length<this.maxpswdCharLen){
    //           delete this.errors.isOldPswdLengthFormatValid;
    //         }
    //         delete this.errors.isOldPswdFormatValid;
    //       }
    //       else{
    //         //this.newpass = oldval;
    //         this.errors.isOldPswdLengthFormatValid = true;
    //       }
    //       this.pswdValidationResult = true;
    //     }
    //     else
    //     {
    //       this.pswdValidationResult = false;
    //       this.errors.isOldPswdFormatValid = true;
    //     }
    //   }
    //   else
    //   {
    //       this.hasLowerCaseChar = false;
    //       this.hasUpperCaseChar = false;
    //       this.hasNumberChar = false;
    //       this.hasSpecialChar = false;
    //       this.hasPassLength = false;
    //       this.pswdValidationResult = false;
    //       delete this.errors.isOldPswdLengthFormatValid;
    //       delete this.errors.isOldPswdFormatValid;
    //   }
    // },
  },
};
</script>

<style type="text/css" >
* {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
}
html,
body {
  font-family: "Poppins", sans-serif !important;
  margin: 0;
  padding: 0;
  width: 100%;
}
html {
  font-size: 14px;
  height: 100%;
}
body {
  font-size: 14px;
  line-height: 1.42857143;
  color: #000000;
  height: 100%;
}
/* body {position: relative;  padding-bottom: 70px !important;   min-height:100%;} */

a {
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  transition-property: color, background-color, opacity;
}
a:hover {
  text-decoration: none !important;
}
/*Heading*/
h1 {
  font-size: 28px;
  font-weight: 500;
}
h2 {
  font-size: 28px;
  font-weight: 400;
}
h3 {
  font-size: 22px;
  font-weight: normal;
}
h4 {
  font-size: 19px;
  font-weight: normal;
}
h5 {
  font-size: 17px;
  font-weight: 500;
}
/*margin*/
.mart-40 {
  margin-top: 40px !important;
}
.mart-15 {
  margin-top: 15px !important;
}
.primary-btn {
  padding: 8px 15px;
  font-size: 14px;
  font-weight: 500;
  background: #0056e0;
  color: #ffffff;
  border: solid 1px #0056e0;
  border-radius: 0px;
  text-decoration: none;
  -webkit-transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  min-width: 115px;
  float: left;
  text-align: center;
}
.primary-btn:hover {
  background: #0043a4;
  color: #ffffff;
  text-decoration: none;
  border-color: #0043a4;
}
.secondary-btn {
  padding: 8px 15px;
  font-size: 14px;
  font-weight: 500;
  background: #ffffff;
  color: #0056e0;
  border: solid 1px #0056e0;
  border-radius: 0px;
  text-decoration: none;
  -webkit-transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  min-width: 115px;
  float: left;
  text-align: center;
}
.secondary-btn:hover {
  background: #0056e0;
  color: #ffffff;
  text-decoration: none;
  border-color: #0056e0;
}
.padl-0 {
  padding-left: 0 !important;
}
.ripple {
  position: relative;
  overflow: hidden;
}
.ripple:after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 5px;
  height: 5px;
  background: rgba(255, 255, 255, 0.5);
  opacity: 0;
  border-radius: 100%;
  transform: scale(1, 1) translate(-50%);
  transform-origin: 50% 50%;
}
@keyframes ripple {
  0% {
    transform: scale(0, 0);
    opacity: 1;
  }
  20% {
    transform: scale(25, 25);
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: scale(40, 40);
  }
}
.ripple:focus {
  box-shadow: none;
}
.ripple:focus:not(:active)::after {
  animation: ripple 1s ease-out;
}
/*Sign in*/
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px white inset !important;
}

.login_hold {
  border: 1px solid #e4e8e7;
  border-radius: 3px;
  box-shadow: 0 0 3px 1px #e0dde0;
}
.login_main {
  padding: 12% 10% 19%;
}
.login_img {
  max-height: 440px;
}
.login_img img {
  height: 100%;
  width: 100%;
}
.login_hold .logoholder {
  margin-bottom: 40px;
}
select {
  appearance: none;
  -webkit-appearance: none;
}
select:focus {
  border-color: #0056e0 !important;
}
.select:after {
  position: absolute;
  top: 13px;
  right: 20px;
  width: 20px;
  height: 20px;
  padding: 4px;
  content: "";
  pointer-events: none;
  background: #ffffff url(../static/images/arrow-down.png) 0px 0px no-repeat;
}
.signin-container input,
select {
  display: block;
  width: 100%;
  background: #ffffff !important;
  height: 45px !important;
  border: none !important;
  border: solid 1px #d2d4d5 !important;
  padding: 0 15px;
  font-size: 14px !important;
  font-weight: 500 !important;
  color: #1d1d1d !important;
  box-shadow: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
}
.signin-container input:focus {
  box-shadow: none;
  outline: none;
  border-color: #0056e0 !important;
  -webkit-transition-property: right;
  transition-property: right;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-timing-function: ease-out;
  transition-timing-function: ease-out;
}
.signin-container input:focus ~ label {
  color: #0056e0;
}
.signin-container input:focus ~ label,
.signin-container input:valid ~ label {
  top: -10px;
  font-size: 13px;
  left: 10px;
  font-weight: lighter;
  background: #ffffff;
  padding: 0 5px;
}
.signin-container label {
  position: absolute;
  top: 12px;
  left: 15px;
  pointer-events: none;
  color: #8f8f8f;
  font-size: 14px;
  font-weight: lighter;
  -webkit-transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.signin-container .material-icons {
  position: absolute;
  top: 5px;
  left: -2px;
  color: #606060;
}
.signin-main {
  width: 100%;
  height: 100%;
  display: table;
  min-height: 100%;
}
.signin-container {
  display: table-cell;
  text-align: center;
  vertical-align: middle;
}

.signin-icons {
  position: relative;
}
/* .signin-user:after{content:'';background:url(images/signin-icon.png) no-repeat -5px -5px;width:30px;height:30px;position:absolute;display:block;left:0px;top:9px;}
.singin-password:after{content:'';background:url(images/signin-icon.png) no-repeat -5px -57px;width:30px;height:30px;position:absolute;display:block;left:0px;top:9px;} */
.signin-pass-visible,
.input-visible {
  display: none;
}
#Password:focus ~ .input-visible,
#Password:valid ~ .input-visible {
  display: block;
}
/* .signin-pass-hidden:after{content:'';background:url(images/signin-icon.png) no-repeat 7px -148px;width:30px;height:30px;position:absolute;display:block;right:0px;top:9px;}
.signin-pass-visible:after{content:'';background:url(images/signin-icon.png) no-repeat 7px -107px;width:30px;height:30px;position:absolute;display:block;right:0px;top:9px;} */
.signin-btn {
  float: right;
  margin: 0 auto;
  padding: 10px 35px;
  display: block;
  max-width: 150px;
}
.forgot-hold {
  display: block;
  width: 100%;
  text-align: right;
}
.signin-btn-hold {
  margin-top: 40px;
  display: inline-block;
  width: 100%;
  text-align: right;
}
input::-ms-clear,
input::-ms-reveal {
  display: none;
}
.erroe-message {
  font-size: 13px;
  color: #f44336;
  text-align: left;
  float: left;
  margin-top: 5px;
}
.signin-bottom-hold {
  max-width: 475px;
  margin: 15px auto;
}
.signin-powered {
  float: left;
  font-weight: 500;
}
.signin-powered img {
  padding-left: 5px;
}
.signin-help {
  float: right;
}
.signin-help ul li {
  list-style: none;
  float: left;
  padding: 0 10px;
  color: #111111;
  font-weight: 500;
}
.signin-help ul li:last-child {
  padding-right: 0;
}
.signin-help ul li a {
  color: #111111;
}
.divider-or {
  color: #d2d4d5 !important;
}
.form-group {
  float: left;
  width: 100%;
}
.website-grey-box {
  padding: 20px;
  float: left;
  width: 100%;
  background: #f1f1f1;
  text-align: center;
}
.website-grey-box span {
  float: left;
  margin: 10px 0;
  color: #0056e0;
}
.website-grey-box input {
  float: left;
  width: 55%;
  margin: 0 5px;
}
.container.customcheck {
  float: left;
  width: auto;
  position: relative;
  padding-left: 22px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  pointer-events: all;
  left: 0;
  color: #111111;
  font-weight: 500;
}
.container.customcheck input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.checkmark {
  position: absolute;
  top: 3px;
  left: 0;
  height: 15px !important;
  width: 15px !important;
  background-color: #ffffff !important;
  border-radius: 3px !important;
  border: solid 1px #c4c4c4;
}
.container.customcheck:hover input ~ .checkmark {
  background-color: #ffffff;
  border: solid 1px #c4c4c4;
}
.container.customcheck input:checked ~ .checkmark {
  background-color: #0056e0 !important;
  border: none !important;
}
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.container.customcheck input:checked ~ .checkmark:after {
  display: block;
}
.container.customcheck .checkmark:after {
  left: 5px;
  top: 1px;
  width: 5px;
  height: 10px;
  border: solid #ffffff;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.signin-btn-hold a:focus {
  color: #ffffff !important;
  text-decoration: none !important;
}
.help.is-danger.required {
  text-align: left !important;
}
.spinner_hold {
  position: absolute;
  left: 0;
  right: 0;
  top: 0px;
  bottom: 0;
  background: #ffffff9e;
  z-index: 2;
  display: table;
  width: 100%;
  height: 100%;
}
.spinner_hold .spin {
  display: table-cell;
  width: 100%;
  height: 100%;
  vertical-align: middle;
  font-size: 36px;
}
.signin-main.subscriptionContent {
  position: relative;
  margin-top: -75px;
  min-height: 100vh;
  background: #fff;
  z-index: 10;
  margin-bottom: -38px;
}
.formhold {
  min-height: 100vh;
}
.spinner {
  text-align: center;
  display: table-cell;
  vertical-align: middle;
}

.spinner > div {
  width: 25px;
  height: 25px;
  background-color: #0056e0;
  margin-right: 10px;
  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.8s infinite ease-in-out both;
  animation: sk-bouncedelay 1.8s infinite ease-in-out both;
}

.spinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.spinner .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

.termsColor {
  color: #0056e0;
}

@-webkit-keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
  }
}

@keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
.signin-main.subscriptionContent .row {
  flex-wrap: initial;
}
.signin-hold img {
  height: 50px;
}

@media (max-width: 767px) {
  .signin-hold {
    padding: 0;
  }
  .signin-main.subscriptionContent .row {
    flex-wrap: wrap;
  }
}

.p-relative{
  position:relative;
}

@media (max-width: 479px) {
.signin-icons {
   text-align: left;
}
}

</style>
